// extracted by mini-css-extract-plugin
module.exports = {"resource":"Resource_resource__hHZnk"};